import { render, staticRenderFns } from "./group-add.vue?vue&type=template&id=5e5e3c3e&scoped=true&"
import script from "./group-add.vue?vue&type=script&lang=js&"
export * from "./group-add.vue?vue&type=script&lang=js&"
import style0 from "./group-add.vue?vue&type=style&index=0&id=5e5e3c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e3c3e",
  null
  
)

export default component.exports